import React, { createContext, useState, useContext, useEffect } from "react";

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    // Возвращаем значения по умолчанию, если контекст недоступен
    return {
      isDark: true,
      toggleTheme: () => {},
      theme: {
        body: "#0a0a0f",
        text: "#e0e0e0",
        secondaryText: "#a0a0b0",
        highlight: "#6c5ce7",
        cardBg: "rgba(18, 18, 26, 0.6)",
        border: "rgba(108, 92, 231, 0.15)",
        dark: "#0a0a0f",
        imageHighlight: "#6c5ce7",
        compImgHighlight: "#a29bfe",
        jacketColor: "#6c5ce7",
        headerColor: "#6c5ce7",
        splashBg: "#0a0a0f",
      },
    };
  }
  return context;
};

export const CustomThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("null7x-theme");
    return saved ? saved === "dark" : true;
  });

  useEffect(() => {
    localStorage.setItem("null7x-theme", isDark ? "dark" : "light");
    document.body.setAttribute("data-theme", isDark ? "dark" : "light");
  }, [isDark]);

  const toggleTheme = () => setIsDark(!isDark);

  const theme = isDark
    ? {
        // Dark Theme
        body: "#0a0a0f",
        text: "#e0e0e0",
        secondaryText: "#a0a0b0",
        highlight: "#6c5ce7",
        cardBg: "rgba(18, 18, 26, 0.6)",
        border: "rgba(108, 92, 231, 0.15)",
        // Additional properties for SVG images
        dark: "#0a0a0f",
        imageHighlight: "#6c5ce7",
        compImgHighlight: "#a29bfe",
        jacketColor: "#6c5ce7",
        headerColor: "#6c5ce7",
        splashBg: "#0a0a0f",
      }
    : {
        // Light Theme
        body: "#f5f5f7",
        text: "#1a1a2e",
        secondaryText: "#4a4a5a",
        highlight: "#6c5ce7",
        cardBg: "rgba(255, 255, 255, 0.9)",
        border: "rgba(108, 92, 231, 0.2)",
        // Additional properties for SVG images
        dark: "#1a1a2e",
        imageHighlight: "#6c5ce7",
        compImgHighlight: "#a29bfe",
        jacketColor: "#6c5ce7",
        headerColor: "#6c5ce7",
        splashBg: "#f5f5f7",
      };

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme, theme }}>
      {children}
    </ThemeContext.Provider>
  );
};
